import React, { useState, useEffect } from 'react';
import { Box, Typography, Button, Alert, CircularProgress, Dialog, DialogTitle, DialogContent, DialogActions } from '@mui/material';
import apiClient from '../../services/api';

const PaymentConfirmation = ({
  selectedPackage,
  onPaymentSuccess,
  onBack,
  isAuthenticated,
  onRequireLogin,
}) => {
  const [loading, setLoading] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [payUrl, setPayUrl] = useState('');
  const [hasOpenedPay, setHasOpenedPay] = useState(false);
  const [waitingPay, setWaitingPay] = useState(false);
  const [checkPayMsg, setCheckPayMsg] = useState('');
  const [isPaid, setIsPaid] = useState(false);
  console.log(selectedPackage)
  useEffect(() => {
    if (checkPayMsg) {
      const timer = setTimeout(() => {
        setCheckPayMsg('');
      }, 3000);
      return () => clearTimeout(timer);
    }
  }, [checkPayMsg]);

  const handlePay = async () => {
    if (!isAuthenticated) {
      onRequireLogin?.();
      return;
    }
    setLoading(true);
    try {
      const res = await apiClient.post('/api/pay', {
        packageId: selectedPackage?.id,
        packageName: selectedPackage?.name,
        price: selectedPackage?.price,
      });
      if (res && res.success && res.data) {
        if (res.data.status === 'paid') {
          setIsPaid(true);
          setWaitingPay(false);
          setPayUrl('');
          setModalOpen(false);
          // 不自动调用 onPaymentSuccess，等用户点击“下一步”
        } else if (res.data.pay_url) {
          setPayUrl(res.data.pay_url);
          setWaitingPay(true);
          setModalOpen(true);
          setHasOpenedPay(false);
        } else {
          alert(res?.message || '支付失败，请重试');
        }
      } else {
        alert(res?.message || '支付失败，请重试');
      }
    } catch (err) {
      alert('支付失败，请重试');
    } finally {
      setLoading(false);
    }
  };

  const getPayUrlQueryString = (payUrl) => {
    if (!payUrl) return '';
    const idx = payUrl.indexOf('?');
    return idx !== -1 ? payUrl.substring(idx + 1) : '';
  };

  const handleCheckPayResult = async () => {
    try {
      const queryString = getPayUrlQueryString(payUrl);
      const url = queryString ? `/api/pay/check?${queryString}` : '/api/pay/check';
      const res = await apiClient(url);
      if (res && res.success && res.data && res.data.status === 'paid') {
        setModalOpen(false);
        setCheckPayMsg('');
        setIsPaid(true); // 只设置已支付，不立即进入下一步
        // 不要在这里调用 onPaymentSuccess
      } else {
        setCheckPayMsg('订单尚未支付，请完成支付后再点击');
      }
    } catch (e) {
      setCheckPayMsg('查询支付结果失败，请稍后重试');
    }
  };

  const handleAbandonPay = async () => {
    setModalOpen(false);
    try {
      const queryString = getPayUrlQueryString(payUrl);
      const url = queryString ? `/api/pay/close?${queryString}` : '/api/pay/close';
      const res = await apiClient(url, { method: 'POST' });
      if (res && res.success) {
        setWaitingPay(false);
        setPayUrl('');
        // 可选：重置其他相关状态
      }
    } catch (e) {
      // 可选：错误处理
    }
  };

  return (
    <Box>
      <Typography variant="h5" sx={{ mb: 3, fontWeight: 600 }}>
        第四步：付款确认
      </Typography>
      <Alert severity="info" sx={{ mb: 3 }}>
        请确认您的订单信息并完成支付
      </Alert>
      <Box sx={{ textAlign: 'center', py: 4 }}>
        {selectedPackage ? (
          <Box sx={{ mb: 2 }}>
            <Typography variant="h6">
              套餐：{selectedPackage.name}
            </Typography>
            <Typography variant="h6" color="primary">
              价格：¥{selectedPackage.price}
              {isPaid && (
                <Typography component="span" color="success.main" sx={{ ml: 2 }}>
                  已支付
                </Typography>
              )}
            </Typography>
          </Box>
        ) : (
          <Alert severity="warning">未选择套餐</Alert>
        )}
        <Button
          variant="contained"
          onClick={handlePay}
          disabled={loading || !selectedPackage || waitingPay || isPaid}
        >
          {loading
            ? <CircularProgress size={24} />
            : waitingPay
              ? '等待支付'
              : isPaid
                ? '已支付'
                : '去支付'}
        </Button>
        {isPaid && (
          <Button
            variant="contained"
            color="success"
            sx={{ ml: 2 }}
            onClick={() => onPaymentSuccess?.({ status: 'paid' })}
          >
            下一步
          </Button>
        )}
      </Box>
      <Box sx={{ mt: 3, display: 'flex', justifyContent: 'space-between' }}>
        <Button variant="outlined" onClick={onBack} disabled={loading}>
          返回上一步
        </Button>
      </Box>

      {/* 支付弹窗 */}
      <Dialog open={modalOpen} onClose={() => setModalOpen(false)}>
        <DialogTitle>支付确认</DialogTitle>
        <DialogContent>
          <Typography sx={{ mb: 2 }}>请点击下方按钮前往支付页面完成支付。</Typography>
          {checkPayMsg && (
            <Box mt={2} color="error.main" textAlign="center">
              {checkPayMsg}
            </Box>
          )}
        </DialogContent>
        <DialogActions>
          {!hasOpenedPay ? (
            <>
              <Button
                variant="contained"
                color="primary"
                onClick={() => {
                  if (payUrl) {
                    window.open(payUrl, '_blank');
                    setHasOpenedPay(true);
                  }
                }}
                disabled={!payUrl}
              >
                前往支付
              </Button>
              <Button onClick={handleAbandonPay} color="secondary">
                放弃
              </Button>
            </>
          ) : (
            <>
              <Button
                variant="contained"
                color="primary"
                onClick={() => {
                  if (payUrl) {
                    window.open(payUrl, '_blank');
                    setHasOpenedPay(true);
                  }
                }}
                disabled={!payUrl}
              >
                继续支付
              </Button>
              <Button
                variant="contained"
                color="success"
                onClick={handleCheckPayResult}
              >
                我已支付
              </Button>
              <Button
                color="secondary"
                onClick={handleAbandonPay}
              >
                放弃
              </Button>
            </>
          )}
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default PaymentConfirmation; 